import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import { add as addToWishList } from '../Actions/WishList.action';

export default function FavouriteButton(props) {
    const { articleNumber } = props;
    const dispatch = useDispatch();
    const [isActive, setIsActive] = useState(window.__litium.preloadState.wishlist.items.filter(x => x.articleNumber == articleNumber).length > 0);

    const addProduct = (articleNumber) => {
        let quantity = 1;
        if(!isActive){
            setIsActive(true);
        }
        else{
            setIsActive(false);
            quantity = -1;
        }
        dispatch(
            addToWishList({ articleNumber, quantity })
        )
    }

    return (
        <>
            <div className="favourite">
                <div className="icon-container">
                    <i className={isActive ? "fas fa-bookmark" : "fal fa-bookmark"} onClick={() => addProduct(articleNumber)}></i>
                </div>
            </div>
        </>
    )
}